import styled from 'styled-components';
import {
  boxShadow, secondaryFont, wMedium, maxWidth, retina, minWidthApp, maxTablet,
} from '../../../Utils/utilsStyle';

type Props = {
  companyName: string,
  title?: string,
  colorText?: string,
  sizeText?: string,
  sizeTextSm?: string,
} & typeof defaultProps;

const defaultProps = {
  title: '10002',
  colorText: '#001823',
  sizeText: '38px',
  sizeTextSm: '25px',
};

const Wrapper = styled.div< { colorText: string, sizeText: string, sizeTextSm: string } >`
  box-shadow: ${boxShadow};
  border-radius: 8px;
  text-align:center;
  padding-top: 0px;
  min-width: 228px;
  min-height: 146px;
  margin: 20px 10px;
  margin-bottom: 0px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: ${boxShadow};
  @media all and (max-width: ${minWidthApp}) {
    min-width: 100%;
  }
  span {
    display:block;
  }
  .title {
    color: ${(props) => props.colorText};
    font-family: ${secondaryFont};
    font-weight: ${wMedium};
    font-size: ${(props) => props.sizeText};
    line-height: ${(props) => props.sizeText};
    letter-spacing: -0.97;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: ${(props) => props.sizeTextSm};
      line-height: ${(props) => props.sizeTextSm};
    }
    @media all and (max-width: ${maxTablet}) {
     font-size: 25px;
     line-height: 28px;
    }
  }
  .companyName{
    color: #001823;
    font-family: ${secondaryFont};
    font-weight: ${wMedium};
    font-size: 20px;
    line-height: 1.211;
    letter-spacing: -0.49;
    margin-top: 25px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 15px;
      font-size: 16px;
    }
  }
`;

const StatesWidgetPrimary = function StatesWidgetPrimary(props: Props) {
  const {
    companyName, title, colorText, sizeText, sizeTextSm,
  } = props;
  return (
    <Wrapper className="StatesWidgetPrimary-col-size" colorText={colorText} sizeText={sizeText} sizeTextSm={sizeTextSm}>
      <span className="title">{title?.length ? title : 'N/A'}</span>
      <span className="companyName">{companyName?.length ? companyName : 'N/A'}</span>
    </Wrapper>
  );
};

StatesWidgetPrimary.defaultProps = defaultProps;

export default StatesWidgetPrimary;
